/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Rounds_N_PlayersInputs */



/**
* | output |
* | --- |
* | "({count} players)" |
*
* @param {Rounds_N_PlayersInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_n_players = /** @type {((inputs: Rounds_N_PlayersInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_N_PlayersInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`(${i?.count} joueurs)`)
	if (locale === "es") return /** @type {LocalizedString} */ (`(${i?.count} jugadores)`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`(${i?.count} jogadores)`)
	if (locale === "it") return /** @type {LocalizedString} */ (`(${i?.count} giocatori)`)
	return /** @type {LocalizedString} */ (`(${i?.count} players)`)
});